"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardList = exports.ActivityList = exports.ActivityCategoryType = exports.ActivityType = exports.ActivityChannelType = exports.GET_PROMOTIONS_PUSH_NOTIFICATION_OPT_IN_ACTIVITY = exports.GET_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY = exports.RESET_SIGN_IN_ACTIVITY = exports.FETCH_REWARD_BARCODE_DATA = exports.RESET_ACTIVITY_DETAILS = exports.FETCH_LOYALTY_ACTIVITIES = exports.FETCH_ACTIVITY_DETAILS = exports.FETCH_REWARD_ENTRY_DETAILS = exports.GET_ACTIVITY_MAPPING = exports.GET_ACTIVITY_MAPPINGS = exports.GET_SIGN_IN_ACTIVITY = exports.GET_INVITE_ACCEPTED_ACTIVITY = exports.GET_INVITE_FRIENDS_ACTIVITY = exports.FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES = exports.ACTIVITY_DETAILS = exports.RESET_ERROR = exports.UPLOAD_PHOTO = exports.RESET_STATE = exports.DOWNLOAD_FILE = exports.RESET_ACTIVITY_COMPLETED = exports.ACTIVITY_COMPLETED = exports.CREDIT_USER_POINTS = exports.UPDATE_USER_POINTS = exports.RESET_SELECTED_ACTIVITY = exports.VALIDATE_PROMO_CODE = exports.GET_CAMPAIGN = exports.SET_SELECTED_ACTIVITY = exports.USER_ACTIVITIES = exports.RESET_SELECTED_REWARD = exports.SET_SELECTED_REWARD = exports.REDEEM_REWARD = exports.REWARDS = exports.REWARD = exports.REWARDS_CATEGORIES = exports.USER_REWARDS = exports.USER_POINTS = void 0;
var ActivityList_1 = require("./ActivityList");
Object.defineProperty(exports, "ActivityList", { enumerable: true, get: function () { return ActivityList_1.ActivityList; } });
var RewardList_1 = require("./RewardList");
Object.defineProperty(exports, "RewardList", { enumerable: true, get: function () { return RewardList_1.RewardList; } });
var ActivityCategoryType;
(function (ActivityCategoryType) {
    ActivityCategoryType[ActivityCategoryType["Share"] = 1] = "Share";
    ActivityCategoryType[ActivityCategoryType["Socialize"] = 2] = "Socialize";
    ActivityCategoryType[ActivityCategoryType["Interact"] = 3] = "Interact";
    ActivityCategoryType[ActivityCategoryType["Buy"] = 4] = "Buy";
})(ActivityCategoryType || (ActivityCategoryType = {}));
exports.ActivityCategoryType = ActivityCategoryType;
var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["Facebook"] = 1] = "Facebook";
    ActivityType[ActivityType["Merchandise"] = 2] = "Merchandise";
    ActivityType[ActivityType["Music"] = 3] = "Music";
    ActivityType[ActivityType["Tickets"] = 4] = "Tickets";
    ActivityType[ActivityType["Twitter"] = 5] = "Twitter";
    ActivityType[ActivityType["Your Site"] = 6] = "Your Site";
    ActivityType[ActivityType["Poll"] = 7] = "Poll";
    ActivityType[ActivityType["Code Redemption"] = 9] = "Code Redemption";
})(ActivityType || (ActivityType = {}));
exports.ActivityType = ActivityType;
var ActivityChannelType;
(function (ActivityChannelType) {
    ActivityChannelType[ActivityChannelType["ad hoc points"] = 1] = "ad hoc points";
    ActivityChannelType[ActivityChannelType["code redemption cgp"] = 2] = "code redemption cgp";
    ActivityChannelType[ActivityChannelType["code redemption other"] = 3] = "code redemption other";
    ActivityChannelType[ActivityChannelType["content creation and share"] = 4] = "content creation and share";
    ActivityChannelType[ActivityChannelType["content download"] = 5] = "content download";
    ActivityChannelType[ActivityChannelType["donation"] = 6] = "donation";
    ActivityChannelType[ActivityChannelType["email open or click"] = 7] = "email open or click";
    ActivityChannelType[ActivityChannelType["email sent from member via program"] = 8] = "email sent from member via program";
    ActivityChannelType[ActivityChannelType["facebook"] = 9] = "facebook";
    ActivityChannelType[ActivityChannelType["foursquare"] = 10] = "foursquare";
    ActivityChannelType[ActivityChannelType["game played"] = 11] = "game played";
    ActivityChannelType[ActivityChannelType["Instagram"] = 12] = "Instagram";
    ActivityChannelType[ActivityChannelType["Mobile client app"] = 13] = "Mobile client app";
    ActivityChannelType[ActivityChannelType["Mobile partner app"] = 14] = "Mobile partner app";
    ActivityChannelType[ActivityChannelType["Program login"] = 15] = "Program login";
    ActivityChannelType[ActivityChannelType["Purchase merchandise"] = 16] = "Purchase merchandise";
    ActivityChannelType[ActivityChannelType["Purchase season ticket or subscription"] = 17] = "Purchase season ticket or subscription";
    ActivityChannelType[ActivityChannelType["Purchase ticket"] = 18] = "Purchase ticket";
    ActivityChannelType[ActivityChannelType["Registration and profile"] = 19] = "Registration and profile";
    ActivityChannelType[ActivityChannelType["Reward redemption"] = 20] = "Reward redemption";
    ActivityChannelType[ActivityChannelType["Survey"] = 21] = "Survey";
    ActivityChannelType[ActivityChannelType["Sweeps"] = 22] = "Sweeps";
    ActivityChannelType[ActivityChannelType["Twitter"] = 23] = "Twitter";
    ActivityChannelType[ActivityChannelType["Web client site activity"] = 24] = "Web client site activity";
    ActivityChannelType[ActivityChannelType["Web other site activity"] = 25] = "Web other site activity";
    ActivityChannelType[ActivityChannelType["Web partner site activity"] = 26] = "Web partner site activity";
    ActivityChannelType[ActivityChannelType["Quiz"] = 28] = "Quiz";
})(ActivityChannelType || (ActivityChannelType = {}));
exports.ActivityChannelType = ActivityChannelType;
var USER_POINTS = 'loyalty/USER_POINTS';
exports.USER_POINTS = USER_POINTS;
var USER_REWARDS = 'loyalty/USER_REWARDS';
exports.USER_REWARDS = USER_REWARDS;
var REWARDS_CATEGORIES = 'loyalty/REWARDS_CATEGORIES';
exports.REWARDS_CATEGORIES = REWARDS_CATEGORIES;
var REWARD = 'loyalty/REWARD';
exports.REWARD = REWARD;
var REWARDS = 'loyalty/REWARDS';
exports.REWARDS = REWARDS;
var REDEEM_REWARD = 'loyalty/REDEEM_REWARD';
exports.REDEEM_REWARD = REDEEM_REWARD;
var SET_SELECTED_REWARD = 'loyalty/SET_SELECTED_REWARD';
exports.SET_SELECTED_REWARD = SET_SELECTED_REWARD;
var RESET_SELECTED_REWARD = 'loyalty/RESET_SELECTED_REWARD';
exports.RESET_SELECTED_REWARD = RESET_SELECTED_REWARD;
var USER_ACTIVITIES = 'loyalty/USER_ACTIVITIES';
exports.USER_ACTIVITIES = USER_ACTIVITIES;
var SET_SELECTED_ACTIVITY = 'loyalty/SET_SELECTED_ACTIVITY';
exports.SET_SELECTED_ACTIVITY = SET_SELECTED_ACTIVITY;
var RESET_SELECTED_ACTIVITY = 'loyalty/RESET_SELECTED_ACTIVITY';
exports.RESET_SELECTED_ACTIVITY = RESET_SELECTED_ACTIVITY;
var GET_CAMPAIGN = 'loyalty/GET_CAMPAIGN';
exports.GET_CAMPAIGN = GET_CAMPAIGN;
var VALIDATE_PROMO_CODE = 'loyalty/VALIDATE_PROMO_CODE';
exports.VALIDATE_PROMO_CODE = VALIDATE_PROMO_CODE;
var UPDATE_USER_POINTS = 'loyalty/UPDATE_USER_POINTS';
exports.UPDATE_USER_POINTS = UPDATE_USER_POINTS;
var CREDIT_USER_POINTS = 'loyalty/CREDIT_USER_POINTS';
exports.CREDIT_USER_POINTS = CREDIT_USER_POINTS;
var ACTIVITY_COMPLETED = 'loyalty/ACTIVITY_COMPLETED';
exports.ACTIVITY_COMPLETED = ACTIVITY_COMPLETED;
var RESET_ACTIVITY_COMPLETED = 'loyalty/RESET_ACTIVITY_COMPLETED';
exports.RESET_ACTIVITY_COMPLETED = RESET_ACTIVITY_COMPLETED;
var DOWNLOAD_FILE = 'loyalty/DOWNLOAD_FILE';
exports.DOWNLOAD_FILE = DOWNLOAD_FILE;
var RESET_STATE = 'loyalty/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
var UPLOAD_PHOTO = 'loyalty/UPLOAD_PHOTO';
exports.UPLOAD_PHOTO = UPLOAD_PHOTO;
var RESET_ERROR = 'loyalty/RESET_ERROR';
exports.RESET_ERROR = RESET_ERROR;
var ACTIVITY_DETAILS = 'loyalty/ACTIVITY_DETAILS';
exports.ACTIVITY_DETAILS = ACTIVITY_DETAILS;
var FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES = 'loyalty/FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES';
exports.FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES = FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES;
var GET_INVITE_FRIENDS_ACTIVITY = 'loyalty/GET_INVITE_FRIENDS_ACTIVITY';
exports.GET_INVITE_FRIENDS_ACTIVITY = GET_INVITE_FRIENDS_ACTIVITY;
var GET_INVITE_ACCEPTED_ACTIVITY = 'loyalty/GET_INVITE_ACCEPTED_ACTIVITY';
exports.GET_INVITE_ACCEPTED_ACTIVITY = GET_INVITE_ACCEPTED_ACTIVITY;
var GET_SIGN_IN_ACTIVITY = 'loyalty/GET_SIGN_IN_ACTIVITY';
exports.GET_SIGN_IN_ACTIVITY = GET_SIGN_IN_ACTIVITY;
var GET_ACTIVITY_MAPPINGS = 'loyalty/GET_ACTIVITY_MAPPINGS';
exports.GET_ACTIVITY_MAPPINGS = GET_ACTIVITY_MAPPINGS;
var GET_ACTIVITY_MAPPING = 'loyalty/GET_ACTIVITY_MAPPING';
exports.GET_ACTIVITY_MAPPING = GET_ACTIVITY_MAPPING;
var FETCH_REWARD_ENTRY_DETAILS = 'loyalty/FETCH_REWARD_ENTRY_DETAILS';
exports.FETCH_REWARD_ENTRY_DETAILS = FETCH_REWARD_ENTRY_DETAILS;
var FETCH_ACTIVITY_DETAILS = 'loyalty/activities/FETCH_ACTIVITY_DETAILS';
exports.FETCH_ACTIVITY_DETAILS = FETCH_ACTIVITY_DETAILS;
var FETCH_LOYALTY_ACTIVITIES = 'loyalty/activities/FETCH_LOYALTY_ACTIVITIES';
exports.FETCH_LOYALTY_ACTIVITIES = FETCH_LOYALTY_ACTIVITIES;
var RESET_ACTIVITY_DETAILS = 'loyalty/activities/RESET_ACTIVITY_DETAILS';
exports.RESET_ACTIVITY_DETAILS = RESET_ACTIVITY_DETAILS;
var FETCH_REWARD_BARCODE_DATA = 'loyalty/rewards/FETCH_BARCODE_DATA';
exports.FETCH_REWARD_BARCODE_DATA = FETCH_REWARD_BARCODE_DATA;
var RESET_SIGN_IN_ACTIVITY = 'loyalty/RESET_SIGN_IN_ACTIVITY';
exports.RESET_SIGN_IN_ACTIVITY = RESET_SIGN_IN_ACTIVITY;
var GET_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY = 'loyalty/GET_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY';
exports.GET_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY = GET_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY;
var GET_PROMOTIONS_PUSH_NOTIFICATION_OPT_IN_ACTIVITY = 'loyalty/GET_PROMOTIONS_PUSH_NOTIFICATION_OPT_IN_ACTIVITY';
exports.GET_PROMOTIONS_PUSH_NOTIFICATION_OPT_IN_ACTIVITY = GET_PROMOTIONS_PUSH_NOTIFICATION_OPT_IN_ACTIVITY;
//# sourceMappingURL=types.js.map